import React from "react";

const TONES = {
  info: "bg-[var(--accent-soft)] text-[var(--ink)] border-[color-mix(in_srgb,var(--accent)_25%,transparent)]",
  warn: "bg-[var(--amber-soft)] text-[var(--amber)] border-transparent",
  danger: "bg-[var(--danger-soft)] text-[var(--danger)] border-transparent",
};

const Banner = ({ tone = "info", icon, children, className = "" }) => (
  <div className={["flex gap-3 items-start rounded-[10px] p-[13px_15px] text-sm border", TONES[tone], className].join(" ")}>
    {icon && <span>{icon}</span>}
    <span>{children}</span>
  </div>
);

export default Banner;
